import { audio } from '../audio/manager.ts';
import { initI18n } from '../i18n/i18n.ts';
import { applySettingsToDocument } from '../state/applySettings.ts';
import { useSettingsStore } from '../state/settingsStore.ts';

/**
 * Keeps the outside world in sync with the settings store: i18next follows the language
 * setting, and `<html>` carries the accessibility/scale attributes that CSS reads.
 * Returns a function that removes the subscriptions (used by tests).
 */
export function bindSettingsToApp(): () => void {
  const apply = () => {
    const { settings } = useSettingsStore.getState();
    initI18n(settings.language);
    applySettingsToDocument(settings);
    audio.applySettings(settings);
  };
  apply();
  const unsubscribe = useSettingsStore.subscribe(apply);

  const mql =
    typeof matchMedia === 'function' ? matchMedia('(prefers-reduced-motion: reduce)') : null;
  mql?.addEventListener('change', apply);

  return () => {
    unsubscribe();
    mql?.removeEventListener('change', apply);
  };
}
